import { render, staticRenderFns } from "./Tp-check.vue?vue&type=template&id=231108fb"
import script from "./Tp-check.vue?vue&type=script&lang=js"
export * from "./Tp-check.vue?vue&type=script&lang=js"
import style0 from "./Tp-check.vue?vue&type=style&index=0&id=231108fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports